import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import PageLayout from '../../components/PageLayout'

export default function ContactPage() {
  const { t } = useTranslation()
  const supportEmail = import.meta.env.VITE_SUPPORT_EMAIL as string

  return (
    <PageLayout withLogin>
      <div className="flex grow flex-col items-center justify-center space-y-8 text-center">
        <h1 className="text-3xl font-bold" data-testid="label-header">
          {t('pages.helpCenter.contact.heading', {
            defaultValue: 'Contact Us',
          })}
        </h1>

        <p className="max-w-md text-lg leading-relaxed text-[#4a5568]">
          {t('pages.helpCenter.contact.description', {
            defaultValue:
              "If you have any questions or need further assistance, please do not hesitate to contact us. We're here to help!",
          })}
        </p>

        <Link
          to={`mailto:${supportEmail}`}
          className="text-primary text-lg font-semibold underline underline-offset-4 hover:opacity-80"
        >
          {supportEmail}
        </Link>
      </div>
    </PageLayout>
  )
}
